import { useState, useEffect } from "react";
import { Alert, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AppConstatnt, CHECK_PAY } from "../../../../../Utils/AppConstant";
import ErrornDialog from "../../../../Common/ErrorDialog/ErrorDialog";
import LoaderButton from "../../../../Common/LoaderButton";
import TransactionDialog from "../../../../Common/TransactionDialog";
import BilledHeader from "../BilledHeader";
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { useDispatch } from "react-redux";
import { currencyConvertor, getControlNumber } from "../../../../../Utils/Utility";
import { injectIntl } from 'react-intl';

function PaperCheckPayment({ intl, loading, onSubmitClick, error, errorresponse, transactionId, title, paymentCodeName, amount, remainingAmount, selection, id, length, paymentType, message, identificationAttribute, total_bill_amount, paymentmethods, originalAmount }) {

    const [paymentData, setpaymentData] = useState({ val1: "", val2: "", identificationNumber: "" });
    const [valid, setValid] = useState(false);
    const [show, setShow] = useState(false);
    const [errorStatus, setErrorStatus] = useState('');
    const dispatch = useDispatch();
    const { formatMessage } = intl;

    useEffect(() => {
        dispatch(clearError());
    }, []);


    function handleChange(e) {

        setpaymentData({
            ...paymentData,
            [e.target.name]: e.target.value
        });
        if (paymentData.val1.length === length) {

            setValid(true);
        }
        else {
            setValid(false)
        }
    }

    useEffect(() => {
        if (paymentData.val1.length === length) {

            setValid(true);
        }
        else {
            setValid(false)
        }

    }, [paymentData.val1])


    function handleSubmit() {
        onSubmitClick(paymentData);
    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <BilledHeader path={`/paymentconfirmation/${id}`} amount={originalAmount} remainingAmount={remainingAmount} selection={selection} total_bill_amount={total_bill_amount} paymentmethods={paymentmethods} />
                    <div className="container_block" style={{ padding: '40px' }}>
                        <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                            <div className="row">
                                {show &&
                                    <div className="col-md-8">
                                        <Alert variant="danger" onClose={() => setShow(false)} dismissible >
                                            {errorStatus}
                                        </Alert>
                                    </div>
                                }
                            </div>
                            <section id="relayPayment_hide">
                                <h4 className="mb-3 txtwhite">{title}</h4>
                                <p>{formatMessage({ id: "app.total_amount_to_pay" })} <strong className="remaining_amt">${amount}</strong></p>
                                <div className="row mt-4">
                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="reMoneyCode">{formatMessage({ id: "app.enter" })} {identificationAttribute}</label>
                                            <input type="text" name="identificationNumber"
                                                className="form-control" placeholder={`${formatMessage({ id: "app.enter" })} ${identificationAttribute}`} onChange={handleChange} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="MoneyCode">{paymentCodeName}</label>

                                            <input type="text" name="val1"
                                                className="form-control" placeholder={paymentCodeName} onChange={handleChange} maxLength={length} />

                                        </div>

                                    </div>



                                    {transactionId && <TransactionDialog
                                        transactionId={transactionId}
                                        statusMessage={`${paymentCodeName} Submitted Successfully`}
                                        open
                                        id={id}
                                        paymentType={paymentType}
                                        message={message}
                                        amount={amount}
                                        remainingAmount={remainingAmount}
                                        selection={selection}
                                        total_bill_amount={total_bill_amount}
                                        load_control_num={getControlNumber()}
                                    />}

                                </div>
                                <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>
                                    <LoaderButton
                                        className="btn btn-chartreuse justify-content-center "
                                        valid={valid}
                                        loading={loading}
                                        onButtonClick={handleSubmit}
                                        name={formatMessage({ id: "app.submit" })}
                                    />
                                </div>
                                {error && !errorStatus && <ErrornDialog
                                    error="Sorry you are experiencing an unknown issue. For immediate assistance, please contact our Contact Support Center at (855)752-2878 to speak with an agent. Thank you."
                                    errorresponse={errorresponse}
                                    open
                                />}
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(PaperCheckPayment);
